import { useState } from "react";
import Button from "./Button.js";
import { verifyMfaCode, resendMfaCode } from "../api/authRequest.js";
import { useTranslation } from "../i18n/TranslationProvider";

const MfaForm = ({ onVerified, onBack }) => {
    const { t } = useTranslation();
    const [mfaCode, setMfaCode] = useState("");
    const [error, setError] = useState("");
    const [resendMessage, setResendMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setResendMessage("");
        setIsSubmitting(true);
        try {
            const res = await verifyMfaCode(mfaCode);
            await onVerified(res.data.userId);
        } catch (err) {
            console.error("Error verifying MFA code:", err);
            setError(err.response?.data?.message || t("auth.mfaInvalidCode"));
            setIsSubmitting(false);
        }
    };

    const handleResend = async () => {
        setError("");
        setResendMessage("");
        try {
            await resendMfaCode();
            setResendMessage(t("auth.codeResent"));
        } catch (err) {
            setError(err.response?.data?.message || t("auth.resendFailed"));
        }
    };

    return (
        <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            <div>
                <label className="block text-sm mb-1 text-gray-500">
                    {t("auth.mfaCodeLabel")}
                </label>
                <input
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    value={mfaCode}
                    onChange={(e) =>
                        setMfaCode(e.target.value.replace(/\D/g, "").slice(0, 6))
                    }
                    placeholder="123456"
                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 text-center tracking-widest text-lg"
                />
            </div>

            {error && <p className="text-red-600 text-center">{error}</p>}
            {resendMessage && <p className="text-teal-600 text-center">{resendMessage}</p>}

            <Button
                type="submit"
                isLoading={isSubmitting}
                disabled={mfaCode.length !== 6 || isSubmitting}
                className="text-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500"
            >
                {t("auth.verify")}
            </Button>

            <div className="flex justify-between items-center mt-2">
                <button
                    type="button"
                    onClick={handleResend}
                    disabled={isSubmitting}
                    className="text-sm text-teal-600 hover:text-teal-700 focus:outline-none"
                >
                    {t("auth.resendCode")}
                </button>
                <button
                    type="button"
                    onClick={onBack}
                    className="text-sm text-gray-500 hover:text-gray-600 focus:outline-none"
                >
                    {t("auth.backToLogin")}
                </button>
            </div>
        </form>
    );
};

export default MfaForm;